import React from "react";
import InputRelation from "../InputRelation";
import InputString from "../InputString";
import InputPassword from "../InputPassword";
import InputNumber from "../InputNumber";
import InputText from "../InputText";
import InputJson from "../InputJson";
import InputImage from "../InputImage";
import InputFile from "../InputFile";
import InputSignature from "../InputSignature";
import InputPointer from "../InputPointer";
import InputSelect from "../InputSelect";
import InputIcon from "../InputIcon";
import RelatedFactory from "../RelatedFactory";
import InputBoolean from "../InputBoolean";
import Input from "../Input";
import getPropertyByPath from "../getPropertyByPath";
import setObjectByPath from "../setObjectByPath";
import InputCurrency from "../InputCurrency";
import InputPhoneWithCountry from "../InputPhone";
import InputOTP from "../InputOTP";

const defaultProps = {
  schemas: [],
};

function InputFactory({
  type,
  _type,
  field,
  object,
  schemas,
  onChange,
  required,
  onProps,
  ...props
}) {
  const reference =
    props.reference && getPropertyByPath(object, props.reference);
  const value = reference || (object && object[field]);
  if (typeof onProps === "function") {
    props = onProps(props, object, field) || props;
  }
  const _onChange = (field, value) => {
    if (object) {
      setObjectByPath(object, props.reference || field, value);
      if (props.reference) {
        const change = {};
        field = setObjectByPath(change, props.reference, value);
        value = change[field];
      }
    }
    onChange(value, field);
  };
  type = _type || type;
  switch (type) {
    case "Email":
    case "String":
      return (
        <InputString
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          type={type.toLowerCase()}
          required={required}
          {...props}
        />
      );
    case "Password":
    case "InputPassword":
      return (
        <InputPassword
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Number":
    case "Tel":
      return (
        <InputNumber
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Text":
    case "InputText":
      return (
        <InputText
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Relation":
      return (
        <InputRelation
          field={field}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema || schemas.find((s) => s.collection === props.target)
          }
          schemas={schemas}
          required={required}
          {...props}
        />
      );
    case "Pointer":
      const schema =
        props.schema || schemas.find((s) => s.collection === props.target);
      if (!schema) return null;
      return (
        <InputPointer
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema || schemas.find((s) => s.collection === props.target)
          }
          schemas={schemas}
          required={required}
          {...props}
        />
      );
    case "Related":
    case "InputRelated":
      return (
        <RelatedFactory
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          schema={
            props.schema || schemas.find((s) => s.collection === props.target)
          }
          schemas={schemas}
          field={field}
          required={required}
          {...props}
        />
      );
    case "Image":
    case "InputImage":
      return (
        <InputImage
          value={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "File":
    case "InputFile":
      return (
        <InputFile
          value={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "InputSignature":
    case "Signature":
      return (
        <InputSignature
          value={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Boolean":
      return (
        <InputBoolean
          value={value}
          onChange={_onChange.bind(this, field)}
          field={field}
          required={required}
          {...props}
        />
      );
    case "Object":
    case "Array":
      return (
        <InputJson
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Enum":
    case "InputSelect":
      return (
        <InputSelect
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          placeholder={
            props.placeholder ||
            (props.dynamic ? "Select of type " : "Select ") +
              (props.label || field)
          }
          required={required}
          {...props}
        />
      );
    case "Icon":
    case "InputIcon":
      return (
        <InputIcon
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Date":
      return (
        <Input
          type={type.toLowerCase()}
          defaultValue={value && value.slice(0, 10)}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Color":
      return (
        <Input
          className="form-control-color"
          type={type.toLowerCase()}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Currency":
    case "InputCurrency":
      return (
        <InputCurrency
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "Phone":
    case "InputPhone":
      return (
        <InputPhoneWithCountry
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
    case "OTP":
    case "InputOTP":
      return (
        <InputOTP
          value={value}
          onChange={_onChange.bind(this, field)}
          {...props}
        />
      );
    default:
      return (
        <Input
          type={type.toLowerCase()}
          defaultValue={value}
          onChange={_onChange.bind(this, field)}
          required={required}
          {...props}
        />
      );
  }
}

InputFactory.defaultProps = defaultProps;
export default InputFactory;
